import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    isVisible?: boolean;
}

export class Separator extends React.Component<IProperties>
{
    public static defaultProps: Partial<IProperties> = {
        isVisible: true
    };

    render()
    {
        if (!this.props.isVisible)
            return null;

        return (
            <div className="contextmenu_separator-container">
                <div className="contextmenu_separator"></div>
            </div>
        );
    }
}